import React from "react";

export const LargeIcon = ({ children }) => {
  return (
    <div className="w-24 h-24 flex items-center justify-center bg-slate-200 rounded-full text-3xl mb-8 text-blue-500">
      {children}
    </div>
  );
};
